import React from 'react';
import { useIntl } from 'react-intl';
import Tag from 'antd/lib/tag';

type Props = {
  flagged?: boolean | null;
};

const FuelTransactionFlagged: React.FC<Props> = ({ flagged }) => {
  const intl = useIntl();

  if (!flagged) return <span>-</span>;

  return (
    <Tag
      data-testid="FuelTransactionFlagged"
      color="red"
      style={{ margin: 0, fontSize: 12, lineHeight: '20px' }}
    >
      {intl.formatMessage({
        id: 'fleetadmin.fuelTransactions.flagged',
        defaultMessage: 'Flagged',
      })}
    </Tag>
  );
};

export default FuelTransactionFlagged;
